export const menu = {
  NaviMenu: "Navigation Menu",
  Home: "Home",
  Friends: "Friends",
  Chats: "Chats",
  Notes: "Notes",
  Play: "Play",
  Etc: "Etc",
  Favorites: "Favorites",
  UserMenu: "User Menu",
  Emoji: "Emoji",
  Sticker: "Sticker",
  GIF: "GIF",
} as const;
